import script from "./WorkingProcedure.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkingProcedure.vue?vue&type=script&setup=true&lang=ts"

import "./WorkingProcedure.vue?vue&type=style&index=0&id=310927b3&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-310927b3"]])

export default __exports__